import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  Slider,
} from "shards-react";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import styles from "./TrainingProSettings.css";
import dayjs from "dayjs";
import { TextField, Tabs, Tab, Box } from "@mui/material";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

import { Line } from "react-chartjs-2";
import * as moment from "moment";

import {
  updateTrainingProConfig,
  fetchTrainingProConfig,
  fetchTrainingProConfigHistory,
} from "../../../providers/services/userService";
import { set, values } from "lodash";

const TrainingProSettings = ({ userUUID, showModal, closeCallback }) => {
  const canvasRef = useRef(null);
  const dioptryUnit = 7;
  const pupillaryDistance = 60 * dioptryUnit;
  const crossSize = 1.5 * dioptryUnit;

  const [selectedTab, setSelectedTab] = useState(0);

  const [leftEyeOffsetX, setLeftEyeOffsetX] = useState(0);
  const [leftEyeOffsetY, setLeftEyeOffsetY] = useState(0);
  const [leftEyePendulumLengthX, setLeftEyePendulumLengthX] = useState(0);
  const [leftEyePendulumLengthY, setLeftEyePendulumLengthY] = useState(0);
  const [leftEyeSpeedX, setLeftEyeSpeedX] = useState(0);
  const [leftEyeSpeedY, setLeftEyeSpeedY] = useState(0);

  const [rightEyeOffsetX, setRightEyeOffsetX] = useState(0);
  const [rightEyeOffsetY, setRightEyeOffsetY] = useState(0);
  const [rightEyePendulumLengthX, setRightEyePendulumLengthX] = useState(0);
  const [rightEyePendulumLengthY, setRightEyePendulumLengthY] = useState(0);
  const [rightEyeSpeedX, setRightEyeSpeedX] = useState(0);
  const [rightEyeSpeedY, setRightEyeSpeedY] = useState(0);

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    fetchUserTrainingConfigHistory();
  }, [selectedDate]);

  useEffect(() => {
    console.log("Selected date:", selectedDate.toISOString());
    // fetch user training config from backend
    // and set the state variables accordingly
    const fetchUserTrainingConfig = async () => {
      try {
        const data = await fetchTrainingProConfig(
          userUUID,
          selectedDate.format("YYYY-MM-DD")
        );

        setLeftEyeOffsetX(data.left_eye_offset_x || 0);
        setLeftEyeOffsetY(data.left_eye_offset_y || 0);
        setLeftEyePendulumLengthX(data.left_eye_pendulum_x || 0);
        setLeftEyePendulumLengthY(data.left_eye_pendulum_y || 0);
        setLeftEyeSpeedX(data.left_eye_speed_x || 0);
        setLeftEyeSpeedY(data.left_eye_speed_y || 0);

        setRightEyeOffsetX(data.right_eye_offset_x || 0);
        setRightEyeOffsetY(data.right_eye_offset_y || 0);
        setRightEyePendulumLengthX(data.right_eye_pendulum_x || 0);
        setRightEyePendulumLengthY(data.right_eye_pendulum_y || 0);
        setRightEyeSpeedX(data.right_eye_speed_x || 0);
        setRightEyeSpeedY(data.right_eye_speed_y || 0);
      } catch (error) {
        console.error("Error fetching user training config:", error);
      }
    };
    fetchUserTrainingConfig();
    console.log("XXXX - fetch user training config", userUUID, selectedDate);
  }, [selectedDate]);

  const updateUserTrainingConfig = async () => {
    let trainingProConfig = {
      left_eye_offset_x: leftEyeOffsetX,
      left_eye_offset_y: leftEyeOffsetY,
      left_eye_pendulum_x: leftEyePendulumLengthX,
      left_eye_pendulum_y: leftEyePendulumLengthY,
      left_eye_speed_x: leftEyeSpeedX,
      left_eye_speed_y: leftEyeSpeedY,
      right_eye_offset_x: rightEyeOffsetX,
      right_eye_offset_y: rightEyeOffsetY,
      right_eye_pendulum_x: rightEyePendulumLengthX,
      right_eye_pendulum_y: rightEyePendulumLengthY,
      right_eye_speed_x: rightEyeSpeedX,
      right_eye_speed_y: rightEyeSpeedY,
    };

    await updateTrainingProConfig(
      userUUID,
      trainingProConfig,
      selectedDate.format("YYYY-MM-DD")
    );
  };

  // const animateViews = () => {
  //   animate(
  //     ".left-view",
  //     {
  //       x: [
  //         0,
  //         leftEyePendulumLengthX * dioptryUnit,
  //         0 - leftEyePendulumLengthX * dioptryUnit,
  //         0
  //       ]
  //     },
  //     {
  //       repeatType: "loop",
  //       repeat: Infinity,
  //       ease: "linear",
  //       duration: leftEyeSpeedX
  //     }
  //   );
  //   animate(
  //     ".left-view",
  //     {
  //       y: [
  //         0,
  //         leftEyePendulumLengthY * dioptryUnit,
  //         0,
  //         -leftEyePendulumLengthY * dioptryUnit,
  //         0
  //       ]
  //     },
  //     {
  //       repeatType: "loop",
  //       repeat: Infinity,
  //       ease: "linear",
  //       duration: leftEyeSpeedY
  //     }
  //   );
  // };

  useEffect(() => {
    setTimeout(() => {
      console.log("DRAWING CANVAS");
      const canvas = canvasRef.current;
      if (canvas) {
        drawCanvas(canvas);
      }
    }, 1000);
  }, [showModal, selectedDate, selectedTab]);

  useEffect(() => {
    setTimeout(() => {
      console.log("DRAWING CANVAS");
      const canvas = canvasRef.current;
      if (canvas) {
        drawCanvas(canvas);
      }
    }, 1000);
  }, [
    leftEyeOffsetX,
    leftEyeOffsetY,
    leftEyePendulumLengthX,
    leftEyePendulumLengthY,
    leftEyeSpeedX,
    leftEyeSpeedY,
    rightEyeOffsetX,
    rightEyeOffsetY,
    rightEyePendulumLengthX,
    rightEyePendulumLengthY,
    rightEyeSpeedX,
    rightEyeSpeedY,
  ]);

  const fetchUserTrainingConfigHistory = async () => {
    try {
      const data = await fetchTrainingProConfigHistory(userUUID);

      const sortedData = data.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      console.log("User training config history:", data);

      let chartData = {
        labels: sortedData.map((item) =>
          moment(item.created_at).format("YYYY-MM-DD")
        ),
        datasets: [
          {
            label: "Left Eye Offset X",
            data: sortedData.map((item) => item.left_eye_offset_x),
            borderColor: "rgba(255, 99, 132, 1)",
            pointStyle: "circle",
          },
          {
            label: "Left Eye Offset Y",
            data: sortedData.map((item) => item.left_eye_offset_y),
            borderColor: "rgba(54, 162, 235, 1)",
          },
          {
            label: "Left Eye Pendulum X",
            data: sortedData.map((item) => item.left_eye_pendulum_x),
            borderColor: "rgba(54, 162, 235, 1)",
          },
          {
            label: "Left Eye Pendulum Y",
            data: sortedData.map((item) => item.left_eye_pendulum_y),
            borderColor: "rgba(255, 206, 86, 1)",
          },
          {
            label: "Left Eye Speed X",
            data: sortedData.map((item) => item.left_eye_speed_x),
            borderColor: "rgba(75, 192, 192, 1)",
          },
          {
            label: "Left Eye Speed Y",
            data: sortedData.map((item) => item.left_eye_speed_y),
            borderColor: "rgba(153, 102, 255, 1)",
          },
          {
            label: "Right Eye Offset X",
            data: sortedData.map((item) => item.right_eye_offset_x),
            borderColor: "rgba(255, 99, 132, 1)",
            borderDash: [5, 5],
          },
          {
            label: "Right Eye Offset Y",
            data: sortedData.map((item) => item.right_eye_offset_y),
            borderColor: "rgba(54, 162, 235, 1)",
            borderDash: [5, 5],
          },
          {
            label: "Right Eye Pendulum X",
            data: sortedData.map((item) => item.right_eye_pendulum_x),
            borderColor: "rgba(54, 162, 235, 1)",
            borderDash: [5, 5],
          },
          {
            label: "Right Eye Pendulum Y",
            data: sortedData.map((item) => item.right_eye_pendulum_y),
            borderColor: "rgba(255, 206, 86, 1)",
            borderDash: [5, 5],
          },
          {
            label: "Right Eye Speed X",
            data: sortedData.map((item) => item.right_eye_speed_x),
            borderColor: "rgba(75, 192, 192, 1)",
            borderDash: [5, 5],
          },
          {
            label: "Right Eye Speed Y",
            data: sortedData.map((item) => item.right_eye_speed_y),
            borderColor: "rgba(153, 102, 255, 1)",
            borderDash: [5, 5],
          },
        ],
      };

      console.log("Chart data:", chartData);

      setChartData(chartData);
    } catch (error) {
      console.error("Error fetching user training config history:", error);
    }
  };

  const useDebouncedSliderCallback = (callback, delay = 50) => {
    const timeoutRef = useRef(null);

    const debouncedCallback = useCallback(
      (...args) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          callback(...args); // <-- pass all arguments
        }, delay);
      },
      [callback, delay]
    );

    useEffect(() => {
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, []);

    return debouncedCallback;
  };

  const handlers = {
    setLeftEyeOffsetX,
    setLeftEyeOffsetY,
    setLeftEyePendulumLengthX,
    setLeftEyePendulumLengthY,
    setLeftEyeSpeedX,
    setLeftEyeSpeedY,
    setRightEyeOffsetX,
    setRightEyeOffsetY,
    setRightEyePendulumLengthX,
    setRightEyePendulumLengthY,
    setRightEyeSpeedX,
    setRightEyeSpeedY,
  };

  const sliderChangeHandler = useDebouncedSliderCallback((handlerID, value) => {
    handlers[handlerID](value);
  });

  const drawCanvas = (canvas) => {
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const width = canvas.width;
    const height = canvas.height;
    const eyeCenterHorizontalMargin = (width - pupillaryDistance) / 2;

    // draw left eye dioptries
    const leftEyeCenter = {
      x: eyeCenterHorizontalMargin,
      y: height / 2,
    };
    drawEyeDioptries(ctx, leftEyeCenter);

    // draw right eye dioptries
    const rightEyeCenter = {
      x: width - eyeCenterHorizontalMargin,
      y: height / 2,
    };
    drawEyeDioptries(ctx, rightEyeCenter);

    // draw left eye offset
    drawCross(ctx, {
      x: leftEyeCenter.x + leftEyeOffsetX * dioptryUnit,
      y: leftEyeCenter.y + leftEyeOffsetY * dioptryUnit,
    });

    // draw left eye start pendulum
    drawCross(ctx, {
      x:
        leftEyeCenter.x +
        leftEyeOffsetX * dioptryUnit +
        (leftEyePendulumLengthX / 2) * dioptryUnit,
      y:
        leftEyeCenter.y +
        leftEyeOffsetY * dioptryUnit +
        (leftEyePendulumLengthY / 2) * dioptryUnit,
    });

    // draw left eye end pendulum
    drawCross(ctx, {
      x:
        leftEyeCenter.x +
        leftEyeOffsetX * dioptryUnit -
        (leftEyePendulumLengthX / 2) * dioptryUnit,
      y:
        leftEyeCenter.y +
        leftEyeOffsetY * dioptryUnit -
        (leftEyePendulumLengthY / 2) * dioptryUnit,
    });

    // draw right eye
    drawCross(ctx, {
      x: rightEyeCenter.x - rightEyeOffsetX * dioptryUnit,
      y: rightEyeCenter.y + rightEyeOffsetY * dioptryUnit,
    });

    // draw right eye start pendulum
    drawCross(ctx, {
      x:
        rightEyeCenter.x -
        rightEyeOffsetX * dioptryUnit -
        (rightEyePendulumLengthX / 2) * dioptryUnit,
      y:
        rightEyeCenter.y +
        rightEyeOffsetY * dioptryUnit -
        (rightEyePendulumLengthY / 2) * dioptryUnit,
    });

    // draw right eye end pendulum
    drawCross(ctx, {
      x:
        rightEyeCenter.x -
        rightEyeOffsetX * dioptryUnit +
        (rightEyePendulumLengthX / 2) * dioptryUnit,
      y:
        rightEyeCenter.y +
        rightEyeOffsetY * dioptryUnit +
        (rightEyePendulumLengthY / 2) * dioptryUnit,
    });
  };

  const drawEyeDioptries = (context, center) => {
    context.lineWidth = 1;
    context.strokeStyle = "black";

    const minRadius = 0;
    const maxRadius = 15 * dioptryUnit;

    var radius = minRadius;

    while (radius < maxRadius) {
      context.beginPath();
      context.arc(center.x, center.y, radius, 0, 2 * Math.PI);
      context.stroke();
      radius += dioptryUnit;
    }
  };

  const drawCross = (context, center) => {
    context.beginPath();
    context.lineWidth = 2;
    context.strokeStyle = "red";
    context.moveTo(center.x - crossSize / 2, center.y - crossSize / 2);
    context.lineTo(center.x + crossSize / 2, center.y + crossSize / 2);
    context.stroke();

    context.beginPath();
    context.moveTo(center.x - crossSize / 2, center.y + crossSize / 2);
    context.lineTo(center.x + crossSize / 2, center.y - crossSize / 2);
    context.stroke();
  };

  const marks = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5];
  const speedMarks = [0, 1, 2, 3, 4, 5];

  const renderRightEyeYControls = () => {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Offset</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            range={{
              min: -5.0,
              max: 5.0,
            }}
            start={[rightEyeOffsetY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler("setRightEyeOffsetY", parseFloat(offset[0]));
            }}
            step={0.25}
            pips={{
              mode: "values",
              values: marks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D`,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Pendulum</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            connect
            range={{
              min: -5.0,
              max: 5.0,
            }}
            start={[rightEyePendulumLengthY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler(
                "setRightEyePendulumLengthY",
                parseFloat(offset[0])
              );
            }} // Event handler for change
            step={0.25}
            pips={{
              mode: "values",
              values: marks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D`,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Speed</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            connect
            range={{
              min: 0,
              max: 5,
            }}
            start={[rightEyeSpeedY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler("setRightEyeSpeedY", parseFloat(offset[0]));
            }}
            step={0.1}
            pips={{
              mode: "values",
              values: speedMarks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D/s`,
            }}
          />
        </div>
      </div>
    );
  };
  const renderLeftEyeYControls = () => {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Speed</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            connect
            range={{
              min: 0,
              max: 5,
            }}
            start={[leftEyeSpeedY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler("setLeftEyeSpeedY", parseFloat(offset[0]));
            }} // Event handler for change
            step={0.1}
            pips={{
              mode: "values",
              values: speedMarks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D/s`,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Pendulum</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            connect
            range={{
              min: -5.0,
              max: 5.0,
            }}
            start={[leftEyePendulumLengthY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler(
                "setLeftEyePendulumLengthY",
                parseFloat(offset[0])
              );
            }} // Event handler for change
            step={0.25}
            pips={{
              mode: "values",
              values: marks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D`,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <label>Offset</label>
          <Slider
            height={"400px"}
            className={styles.slider}
            orientation={"vertical"}
            connect
            range={{
              min: -5.0,
              max: 5.0,
            }}
            start={[leftEyeOffsetY]} // Current value
            onSlide={(offset) => {
              sliderChangeHandler("setLeftEyeOffsetY", parseFloat(offset[0]));
            }} // Event handler for change
            step={0.25}
            pips={{
              mode: "values",
              values: marks,
              density: 2.5,
            }}
            tooltips={{
              // only "to" is needed for tooltips
              to: (v) => `${v} D`,
            }}
          />
        </div>
      </div>
    );
  };

  const renderCanvas = () => {
    return (
      <div
        style={{
          position: "relative",
          display: "inline-block",
          flex: 2,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <canvas ref={canvasRef} width={650} height={250}></canvas>

        <div
          style={{
            display: "flex",
            flexDirection: "rows",
            position: "absolute",
            top: 0,
            left: 0,
            width: 650,
            height: 250,
            pointerEvents: "none", // Allow interactions to pass through to the canvas
            backgroundColor: "rgba(255, 0, 0, 0.1)", // Optional: semi-transparent background
          }}
        >
          <div
            className="left-view"
            style={{
              flex: 1,
              backgroundColor: "rgba(255, 0, 0, 0.3)", // Optional: for visibility
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
            }}
          ></div>
          <div
            className="right-view"
            style={{
              flex: 1,
              backgroundColor: "rgba(0, 0, 255, 0.3)", // Optional: for visibility
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
            }}
          ></div>
        </div>
      </div>
    );
  };

  const renderLeftEyeXControls = () => {
    return (
      <div
        style={{
          maxWidth: 800,
          flex: 1,
        }}
      >
        <label>Left Eye Offset X</label>
        <Slider
          connect
          range={{
            min: -5.0,
            max: 5.0,
          }}
          start={leftEyeOffsetX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler("setLeftEyeOffsetX", parseFloat(offset[0]));
          }} // Event handler for change
          step={0.25}
          pips={{
            mode: "values",
            values: marks,
            density: 2.5,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D`,
          }}
        />
        <label>Left Eye Pendulum X</label>
        <Slider
          connect
          range={{
            min: -5.0,
            max: 5.0,
          }}
          start={leftEyePendulumLengthX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler(
              "setLeftEyePendulumLengthX",
              parseFloat(offset[0])
            );
          }} // Event handler for change
          step={0.5}
          pips={{
            mode: "values",
            values: marks,
            density: 5,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D`,
          }}
        />
        <label>Left Eye Speed X</label>
        <Slider
          connect
          range={{
            min: 0,
            max: 5.0,
          }}
          start={leftEyeSpeedX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler("setLeftEyeSpeedX", parseFloat(offset[0]));
          }} // Event handler for change
          step={0.2}
          pips={{
            mode: "values",
            values: speedMarks,
            density: 4,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D/s`,
          }}
        />
      </div>
    );
  };

  const renderChart = () => {
    let options = {
      responsive: true,
      legend: {
        display: true,
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 10,
          boxHeight: 10,
        },
      },
    };
    return (
      <Box value="2">
        <Line data={chartData} options={options} />
      </Box>
    );
  };

  const renderRightEyeXControls = () => {
    return (
      <div
        style={{
          maxWidth: 800,
          flex: 1,
          paddingLeft: 30,
          paddingRight: 20,
        }}
      >
        <label>Right Eye Offset X</label>
        <Slider
          connect
          range={{
            min: -5.0,
            max: 5.0,
          }}
          start={rightEyeOffsetX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler("setRightEyeOffsetX", parseFloat(offset[0]));
          }} // Event handler for change
          step={0.25}
          pips={{
            mode: "values",
            values: marks,
            density: 2.5,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D`,
          }}
        />
        <label>Right Eye Pendulum X</label>
        <Slider
          connect
          range={{
            min: -5,
            max: 5,
          }}
          start={rightEyePendulumLengthX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler(
              "setRightEyePendulumLengthX",
              parseFloat(offset[0])
            );
          }} // Event handler for change
          step={0.5}
          pips={{
            mode: "values",
            values: marks,
            density: 5,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D`,
          }}
        />
        <label>Right Eye Speed X</label>
        <Slider
          connect
          range={{
            min: 0,
            max: 5.0,
          }}
          start={rightEyeSpeedX} // Current value
          onSlide={(offset) => {
            sliderChangeHandler("setRightEyeSpeedX", parseFloat(offset[0]));
          }} // Event handler for change
          step={0.2}
          pips={{
            mode: "values",
            values: speedMarks,
            density: 4,
          }}
          tooltips={{
            // only "to" is needed for tooltips
            to: (v) => `${v} D/s`,
          }}
        />
      </div>
    );
  };

  return (
    <Modal open={showModal} className={styles.modal}>
      <ModalHeader style={{ padding: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, value) => {
                setSelectedTab(value);
              }}
            >
              <Tab label="Training Configs" />
              <Tab label="History" />
            </Tabs>
          </Box>
          {selectedTab == 0 && (
            <div
              style={{
                padding: "8px",
                marginLeft: "auto",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                    },
                  }}
                  orientation="portrait"
                />
              </LocalizationProvider>
            </div>
          )}
        </div>
      </ModalHeader>
      <ModalBody>
        {selectedTab == 0 && (
          <Box>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: "400px",
              }}
            >
              {renderLeftEyeYControls()}
              <div
                style={{ flex: 1, display: "flex", justifyContent: "center" }}
              >
                {renderCanvas()}
              </div>
              {renderRightEyeYControls()}
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                paddingLeft: 20,
                paddingRight: 30,
              }}
            >
              {renderLeftEyeXControls()}
              <div style={{ flex: 1 }} />
              {renderRightEyeXControls()}
            </div>
          </Box>
        )}
        {selectedTab == 1 && <Box value="2">{renderChart()}</Box>}
      </ModalBody>
      <ModalFooter>
        <Button
          variant="secondary"
          onClick={() => {
            closeCallback();
          }}
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={async () => {
            await updateUserTrainingConfig();
            await fetchUserTrainingConfigHistory();
            //closeCallback();
          }}
        >
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TrainingProSettings;
